import { createSlice } from "@reduxjs/toolkit";

// Global "what window am I analyzing" selector for the Dashboard, same
// session-only shape as branchFilterSlice.js (not persisted, so it always
// starts on the sensible default after a fresh login). Deliberately a
// separate slice from branchFilter - this is Dashboard-specific state, not
// an app-wide filter every list page shares the way branch is.
const initialState = {
  periodKey: "THIS_MONTH",
  customPeriodFrom: null,
  customPeriodTo: null,
  compareKey: "PREVIOUS_MONTH",
  customCompareFrom: null,
  customCompareTo: null,
};

const dashboardFilterSlice = createSlice({
  name: "dashboardFilter",
  initialState,
  reducers: {
    periodChanged: (state, action) => {
      state.periodKey = action.payload;
      // A custom compare range only makes sense paired with the specific
      // period it was picked against - reset to a sensible default rather
      // than carrying a stale custom range onto a newly-picked period.
      if (action.payload !== "CUSTOM") {
        state.customPeriodFrom = null;
        state.customPeriodTo = null;
      }
    },
    customPeriodSet: (state, action) => {
      state.periodKey = "CUSTOM";
      state.customPeriodFrom = action.payload.dateFrom;
      state.customPeriodTo = action.payload.dateTo;
    },
    compareChanged: (state, action) => {
      state.compareKey = action.payload;
      if (action.payload !== "CUSTOM") {
        state.customCompareFrom = null;
        state.customCompareTo = null;
      }
    },
    customCompareSet: (state, action) => {
      state.compareKey = "CUSTOM";
      state.customCompareFrom = action.payload.dateFrom;
      state.customCompareTo = action.payload.dateTo;
    },
  },
});

export const { periodChanged, customPeriodSet, compareChanged, customCompareSet } = dashboardFilterSlice.actions;
export default dashboardFilterSlice.reducer;

export const selectDashboardFilter = (state) => state.dashboardFilter;
